import { OutboundDealsDetailPage, OutboundDealsListPage, OutboundShipmentListPage, OutboundSoldItemsCsvReportPage } from 'domains/outbound/deals/pages'
import Phase3OutboundAuthenticationPage from 'domains/phase3-inbound-journey/pages/Phase3OutboundAuthenticationPage'
import InternalRequestListOutboundOpsPage from 'domains/internal-request-ops/pages/internal-request-list-outbound-ops-page'
import InternalRequestDetailOutboundOpsPage from 'domains/internal-request-ops/pages/internal-request-detail-outbound-ops-page'
import {
  SellerOutboundReturnDetailPage,
  SellerOutboundReturnListPage
} from 'domains/seller-outbound-return/pages'

const outbound_team_routes = {
  collapse  : true,
  path      : '/outbound-team',
  name      : 'Outbound Team',
  icon      : 'fas fa-truck text-blue',
  state_key : 'outbound_team_collapse',
  views     : [

    {
      path      : '/inbound-journey/outbound-authentication',
      name      : 'Authentication Product',
      miniName  : 'AP',
      component : Phase3OutboundAuthenticationPage,
      layout    : '/app'
    },
    {
      path      : '/outbound/deals/list',
      name      : 'Order List',
      miniName  : 'L',
      component : OutboundDealsListPage,
      layout    : '/app'
    },
    {
      path      : '/outbound/deals/list?scope=ready_to_ship',
      name      : 'Shipment List',
      miniName  : 'L',
      component : OutboundShipmentListPage,
      layout    : '/app'
    },
    {
      path          : '/outbound/deals/sold-items-csv',
      name          : 'Sold Item CSV Report',
      miniName      : 'SR',
      component     : OutboundSoldItemsCsvReportPage,
      layout        : '/app',
      allowedRoles  : ['owner', 'admin', 'warehouse', 'finance'],
      allowedEmails : ['sweta.sabilillah.belleandkate@gmail.com']
    },
    {
      path      : '/outbound/deals/:id',
      name      : 'Deal Detail',
      miniName  : 'D',
      component : OutboundDealsDetailPage,
      layout    : '/app',
      invisible : true
    },
    {
      collapse  : true,
      name      : 'Internal Request',
      miniName  : 'IR',
      state_key : 'outbound_team_inventory_internal_request_collapse',
      views     : [
        {
          path      : '/outbounds/internal-requests/list-page',
          name      : 'Outbound Ops Queue',
          miniName  : 'Q',
          component : InternalRequestListOutboundOpsPage,
          layout    : '/app'
        },
        {
          path      : '/outbounds/internal-requests/:id',
          name      : 'Outbound Ops Detail',
          component : InternalRequestDetailOutboundOpsPage,
          layout    : '/app',
          invisible : true
        }
      ]
    },
    {
      collapse  : true,
      name      : 'Consignor Return',
      miniName  : 'CR',
      state_key : 'outbound_team_seller_return_collapse',
      views     : [
        {
          path      : '/seller-outbound-returns',
          name      : 'List',
          miniName  : 'L',
          component : SellerOutboundReturnListPage,
          layout    : '/app'
        },
        {
          path      : '/seller-outbound-returns/:id',
          name      : 'Detail',
          component : SellerOutboundReturnDetailPage,
          layout    : '/app',
          invisible : true
        }
      ]
    }
  ]
}

export default outbound_team_routes
